import { render, staticRenderFns } from "./TwoStepPopupSetting.vue?vue&type=template&id=6a444d0e&"
import script from "./TwoStepPopupSetting.vue?vue&type=script&lang=js&"
export * from "./TwoStepPopupSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports